import React from 'react';
import { FaHeart, FaEye, FaCartArrowDown } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const CartBar = ({ cart, likes, isAuth = false }) => {
  return (
    <Link
      to="https://cabinet.geograftour.com/"
      target="_blank"
      className={`search-stat cart-bar ${isAuth}`}
    >
      <span>
        <FaEye />
        {cart.seen}
      </span>
      <span>
        <FaHeart />
        {cart.likes}
      </span>
      <span>
        <FaCartArrowDown />
        {cart.cart}
      </span>
    </Link>
  );
};

export default CartBar;
